var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_209_588)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9451 22.9466C13.9451 20.0288 15.1042 17.2306 17.1674 15.1674C19.2306 13.1042 22.0288 11.9451 24.9466 11.9451H29.9473C32.8522 11.9434 35.6386 10.7929 37.6984 8.74465L41.1989 5.24417C42.2213 4.21602 43.4368 3.40012 44.7756 2.84337C46.1144 2.28661 47.5501 2 49 2C50.4499 2 51.8856 2.28661 53.2244 2.84337C54.5632 3.40012 55.7787 4.21602 56.8011 5.24417L60.3016 8.74465C62.3619 10.7949 65.1522 11.9451 68.0527 11.9451H73.0534C75.9711 11.9451 78.7694 13.1042 80.8326 15.1674C82.8958 17.2306 84.0549 20.0288 84.0549 22.9466V27.9473C84.0549 30.8477 85.205 33.6381 87.2553 35.6984L90.7558 39.1989C91.784 40.2213 92.5999 41.4368 93.1566 42.7756C93.7134 44.1144 94 45.5501 94 47C94 48.4499 93.7134 49.8856 93.1566 51.2244C92.5999 52.5632 91.784 53.7787 90.7558 54.8011L87.2553 58.3016C85.207 60.3614 84.0566 63.1478 84.0549 66.0527V71.0534C84.0549 73.9711 82.8958 76.7694 80.8326 78.8326C78.7694 80.8958 75.9711 82.0549 73.0534 82.0549H68.0527C65.1478 82.0566 62.3614 83.207 60.3016 85.2553L56.8011 88.7558C55.7787 89.784 54.5632 90.5999 53.2244 91.1566C51.8856 91.7134 50.4499 92 49 92C47.5501 92 46.1144 91.7134 44.7756 91.1566C43.4368 90.5999 42.2213 89.784 41.1989 88.7558L37.6984 85.2553C35.6386 83.207 32.8522 82.0566 29.9473 82.0549H24.9466C22.0288 82.0549 19.2306 80.8958 17.1674 78.8326C15.1042 76.7694 13.9451 73.9711 13.9451 71.0534V66.0527C13.9434 63.1478 12.7929 60.3614 10.7447 58.3016L7.24417 54.8011C6.21602 53.7787 5.40012 52.5632 4.84337 51.2244C4.28661 49.8856 4 48.4499 4 47C4 45.5501 4.28661 44.1144 4.84337 42.7756C5.40012 41.4368 6.21602 40.2213 7.24417 39.1989L10.7447 35.6984C12.7929 33.6386 13.9434 30.8522 13.9451 27.9473V22.9466Z",
    fill: "#FFC50B",
    stroke: "white",
    strokeWidth: 3.74793,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_209_588",
    x: 0.169455,
    y: 0.125977,
    width: 97.6611,
    height: 97.6611,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.95652
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.978261
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_209_588"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_209_588",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGold);
export default __webpack_public_path__ + "static/media/gold.37e67804cc0b03fcf1faff7d71f5c820.svg";
export { ForwardRef as ReactComponent };